import React from 'react'

import LoadingBox from 'src/ui/LoadingBox/LoadingBox'

import AchievementWidgetHeaderSkeleton from './AchievementWidgetHeaderSkeleton'

const AchievementWidgetPlaceholder = () => (
  <AchievementWidgetHeaderSkeleton
    nameSection={
      <LoadingBox width="195px" maxWidth="100%" mb="1x" ml="-8px">
        &nbsp;
      </LoadingBox>
    }
  />
)

export default AchievementWidgetPlaceholder
